import { CircularProgress } from '@mui/material';
import {
  CustomDomainStatus,
  useCustomDomainsQuery,
} from '../../../../../../../generated/graphql';
import _ from 'lodash';
import { Link } from 'react-router';
import { PATHS } from '@client/routes';
import { ResetDomainButton } from './ResetDomainButton';
import auth from '@client/components/auth';

export const SettingsPageCustomDomain = ({
  influencerId,
}: {
  influencerId: number;
}) => {
  const { data, loading, error, refetch } = useCustomDomainsQuery({
    variables: {
      id: influencerId,
    },
    fetchPolicy: 'no-cache',
  });

  if (error) {
    return <div>{error.message}</div>;
  }

  if (loading) {
    return (
      <div>
        <CircularProgress />
      </div>
    );
  }
  if (!data?.creator?.customDomains || _.isEmpty(data.creator.customDomains)) {
    return (
      <Link
        to={PATHS.CUSTOM_DOMAIN_SETUP(influencerId)}
        className="text-primary-800"
      >
        Set up custom domain
      </Link>
    );
  }
  const domainData = data.creator.customDomains[0];

  return (
    <div className="flex flex-col gap-4">
      <span className="font-medium">{domainStatus(domainData.status)}</span>
      <div className="flex gap-6 items-center">
        <DomainLink
          influencerId={influencerId}
          status={domainData.status}
          domain={domainData.domain}
        />
        <ResetDomainButton
          influencerId={influencerId}
          domainId={domainData.id}
          refetch={refetch}
        />
      </div>
    </div>
  );
};

const domainStatus = (status: CustomDomainStatus) => {
  if (status === CustomDomainStatus.Error) {
    return 'There was an issue with landing page set up';
  }
  if (status === CustomDomainStatus.InfraRunning) {
    return 'Your landing page set up is completed';
  }
  return 'Your landing page setup is underway. Click the link below to finish.';
};

const DomainLink = ({
  status,
  domain,
  influencerId,
}: {
  status: CustomDomainStatus;
  domain: string;
  influencerId: number;
}) => {
  if (inProgressStatuses.includes(status)) {
    return (
      <Link
        to={PATHS.CUSTOM_DOMAIN_SETUP(influencerId)}
        className="text-primary-800 font-medium underline"
      >
        {domain}
      </Link>
    );
  }
  return (
    <a
      className="text-primary-800 font-medium underline"
      href={`https://${domain}`}
      target="_blank"
      rel="noreferrer"
    >
      {domain}
    </a>
  );
};

const inProgressStatuses = [
  CustomDomainStatus.SslIssued,
  CustomDomainStatus.DnsVerified,
  CustomDomainStatus.Error,
  CustomDomainStatus.Initialized,
];
